import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  id?: string;
}

const GooglePlayAndroidIcon: FC<Props> = (props) => {
  const id0 = `paint0_linear_${props.id}`;
  const id1 = `paint1_linear_${props.id}`;
  const id2 = `paint2_linear_${props.id}`;
  const id3 = `paint3_linear_${props.id}`;

  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="google play android icon"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.518481 0.337358C0.271173 0.603156 0.129028 1.01226 0.129028 1.54385V20.4525C0.129028 20.9841 0.271173 21.3932 0.527726 21.6498L0.594754 21.7064L11.1897 11.1114V10.8734L0.585508 0.280731L0.518481 0.337358Z"
        fill={`url(#${id0})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7145 14.6569L11.1805 11.1218V10.8745L14.7157 7.33939L14.7919 7.38677L18.9731 9.76278C20.1703 10.4377 20.1703 11.5494 18.9731 12.2335L14.7919 14.6096C14.7908 14.6096 14.7145 14.6569 14.7145 14.6569Z"
        fill={`url(#${id1})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7907 14.6096L11.1804 10.9982L0.518433 21.6602C0.907885 22.0785 1.56314 22.1259 2.29582 21.7168L14.7907 14.6096Z"
        fill={`url(#${id2})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7907 7.38794L2.29582 0.28996C1.56429 -0.128384 0.907885 -0.0717575 0.518433 0.346586L11.1793 10.9982L14.7907 7.38794Z"
        fill={`url(#${id3})`}
      />
      <defs>
        <linearGradient
          id={id0}
          x1="10.2383"
          y1="1.3406"
          x2="-6.73296"
          y2="5.86262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.007" stopColor="#00A1FF" />
          <stop offset="0.26" stopColor="#00BEFF" />
          <stop offset="0.512" stopColor="#00D2FF" />
          <stop offset="0.76" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id={id1}
          x1="20.531"
          y1="10.9987"
          x2="-0.161879"
          y2="10.9987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.409" stopColor="#FFBD00" />
          <stop offset="0.775" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id={id2}
          x1="12.8275"
          y1="12.9628"
          x2="-0.797107"
          y2="35.8939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id={id3}
          x1="-2.16545"
          y1="-5.9526"
          x2="3.91291"
          y2="4.2888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.069" stopColor="#2DA771" />
          <stop offset="0.476" stopColor="#15CF74" />
          <stop offset="0.801" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GooglePlayAndroidIcon;
